/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  TenantAnagraficaDTO,
  TenantAnagraficaUpdateDTO,
  TenantContattoCreateDTO,
  TenantContattoDTO,
  TenantContattoUpdateDTO,
  TenantDTO,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    TenantAnagraficaDTOFromJSON,
    TenantAnagraficaDTOToJSON,
    TenantAnagraficaUpdateDTOFromJSON,
    TenantAnagraficaUpdateDTOToJSON,
    TenantContattoCreateDTOFromJSON,
    TenantContattoCreateDTOToJSON,
    TenantContattoDTOFromJSON,
    TenantContattoDTOToJSON,
    TenantContattoUpdateDTOFromJSON,
    TenantContattoUpdateDTOToJSON,
    TenantDTOFromJSON,
    TenantDTOToJSON,
} from '../models/index';

export interface DeleteTenantContattoRequest {
    contattoId: string;
    tenantId: string;
    assistitoId?: string;
}

export interface GetTenantAnagraficaByIdRequest {
    tenantId: string;
}

export interface GetTenantContattiRequest {
    tenantId: string;
    assistitoId?: string;
}

export interface GetTenantContattoByIdRequest {
    contattoId: string;
    tenantId: string;
}

export interface InsertTenantContattoRequest {
    tenantId: string;
    tenantContattoCreateDTO?: TenantContattoCreateDTO;
}

export interface UpdateTenantAnagraficaByIdRequest {
    tenantId: string;
    tenantAnagraficaUpdateDTO?: TenantAnagraficaUpdateDTO;
}

export interface UpdateTenantContattoRequest {
    contattoId: string;
    tenantId: string;
    tenantContattoUpdateDTO?: TenantContattoUpdateDTO;
}

/**
 * 
 */
export class TenantsApi extends runtime.BaseAPI {

    /**
     */
    async deleteTenantContattoRaw(requestParameters: DeleteTenantContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contattoId'] == null) {
            throw new runtime.RequiredError(
                'contattoId',
                'Required parameter "contattoId" was null or undefined when calling deleteTenantContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteTenantContatto().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assistitoId'] != null) {
            queryParameters['assistitoId'] = requestParameters['assistitoId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Contatti/{contattoId}`.replace(`{${"contattoId"}}`, encodeURIComponent(String(requestParameters['contattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTenantContatto(requestParameters: DeleteTenantContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTenantContattoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getTenantAnagraficaByIdRaw(requestParameters: GetTenantAnagraficaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantAnagraficaDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantAnagraficaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Anagrafica`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantAnagraficaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getTenantAnagraficaById(requestParameters: GetTenantAnagraficaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantAnagraficaDTO> {
        const response = await this.getTenantAnagraficaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantContattiRaw(requestParameters: GetTenantContattiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantContattoDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantContatti().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assistitoId'] != null) {
            queryParameters['assistitoId'] = requestParameters['assistitoId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Contatti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantContattoDTOFromJSON));
    }

    /**
     */
    async getTenantContatti(requestParameters: GetTenantContattiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantContattoDTO>> {
        const response = await this.getTenantContattiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantContattoByIdRaw(requestParameters: GetTenantContattoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantContattoDTO>> {
        if (requestParameters['contattoId'] == null) {
            throw new runtime.RequiredError(
                'contattoId',
                'Required parameter "contattoId" was null or undefined when calling getTenantContattoById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantContattoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Contatti/{contattoId}`.replace(`{${"contattoId"}}`, encodeURIComponent(String(requestParameters['contattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantContattoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getTenantContattoById(requestParameters: GetTenantContattoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantContattoDTO> {
        const response = await this.getTenantContattoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantDTOFromJSON));
    }

    /**
     */
    async getTenants(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantDTO>> {
        const response = await this.getTenantsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async insertTenantContattoRaw(requestParameters: InsertTenantContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantContattoDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertTenantContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Contatti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantContattoCreateDTOToJSON(requestParameters['tenantContattoCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantContattoDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertTenantContatto(requestParameters: InsertTenantContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantContattoDTO> {
        const response = await this.insertTenantContattoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTenantAnagraficaByIdRaw(requestParameters: UpdateTenantAnagraficaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTenantAnagraficaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Anagrafica`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantAnagraficaUpdateDTOToJSON(requestParameters['tenantAnagraficaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTenantAnagraficaById(requestParameters: UpdateTenantAnagraficaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTenantAnagraficaByIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTenantContattoRaw(requestParameters: UpdateTenantContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contattoId'] == null) {
            throw new runtime.RequiredError(
                'contattoId',
                'Required parameter "contattoId" was null or undefined when calling updateTenantContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTenantContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Contatti/{contattoId}`.replace(`{${"contattoId"}}`, encodeURIComponent(String(requestParameters['contattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TenantContattoUpdateDTOToJSON(requestParameters['tenantContattoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateTenantContatto(requestParameters: UpdateTenantContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTenantContattoRaw(requestParameters, initOverrides);
    }

}
